var html = document.documentElement;
var body = document.body;
var timeout;
var st = 0;

// Initialize functions
categoryNav();
portalButton();

// Combine all DOM-ready initialization functions
function initializeDOMFeatures() {
    const hasNextPage = document.querySelector('link[rel=next]') !== null;
    
    // Remove pagination elements if no next page exists
    if (!hasNextPage) {
        document.querySelector('.load-more')?.remove();
        document.querySelector('.gh-loadmore')?.remove();
    } else {
        // Initialize pagination only for non-index pages with feed
        const isMasonry = document.querySelector('.masonry-wrapper') !== null;
        const hasFeed = document.querySelector('.gh-feed') !== null;
        const isIndexPage = document.body.classList.contains('home-template');
        
        if (hasFeed && !isIndexPage && !window.paginationInitialized) {
            pagination(true, null, isMasonry);
            window.paginationInitialized = true;
        }
    }

    setupFootnotes();
    setMasonryAnimationDelay();
    initMasonryLayout();
}

// Call functions when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeDOMFeatures);
} else {
    initializeDOMFeatures();
}

// Prospero nav icons: Font Awesome Free 6.5.2 (https://fontawesome.com, icons CC BY 4.0), inlined so they
// are present on first paint. Formerly set via code injection (<i class="fa ...">), which flashed '#' first.
const pxNavIcons = {
    'home': '<svg class="px-fa" aria-hidden="true" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c0 2.7-.2 5.4-.5 8.1V472c0 22.1-17.9 40-40 40H456c-1.1 0-2.2 0-3.3-.1c-1.4 .1-2.8 .1-4.2 .1H416 392c-22.1 0-40-17.9-40-40V448 384c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32v64 24c0 22.1-17.9 40-40 40H160 128.1c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2H104c-22.1 0-40-17.9-40-40V360c0-.9 0-1.9 .1-2.8V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L564.8 231.5c8 7 12 15 11 24z"/></svg>',
    'blog': '<svg class="px-fa" aria-hidden="true" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M64 32C28.7 32 0 60.7 0 96v64c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm280 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm48 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM64 288c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V352c0-35.3-28.7-64-64-64H64zm280 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"/></svg>',
    'armory': '<svg class="px-fa" aria-hidden="true" fill="currentColor" fill-rule="evenodd" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 16 64 96v128c0 128 88 232 192 272 104-40 192-144 192-272V96zm0 64v360c-72-34-136-116-136-216v-90z"/></svg>',
    'next': '<svg class="px-fa" aria-hidden="true" fill="currentColor" fill-rule="evenodd" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 8a248 248 0 1 0 0 496 248 248 0 1 0 0-496zm0 56a192 192 0 1 1 0 384 192 192 0 1 1 0-384zM352 160l-64 128-128 64 64-128z"/></svg>',
    'about-me': '<svg class="px-fa" aria-hidden="true" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M103.3 344.3c-6.5-14.2-6.9-18.3 7.4-23.1 25.6-8 8 9.2 43.2 49.2h.3v-93.9c1.2-50.2 44-92.2 97.7-92.2 53.9 0 97.7 43.5 97.7 96.8 0 63.4-60.8 113.2-128.5 93.3-10.5-4.2-2.1-31.7 8.5-28.6 53 0 89.4-10.1 89.4-64.4 0-61-77.1-89.6-116.9-44.6-23.5 26.4-17.6 42.1-17.6 157.6 50.7 31 118.3 22 160.4-20.1 24.8-24.8 38.5-58 38.5-93 0-35.2-13.8-68.2-38.8-93.3-24.8-24.8-57.8-38.5-93.3-38.5s-68.8 13.8-93.5 38.5c-.3.3-16 16.5-21.2 23.9l-.5.6c-3.3 4.7-6.3 9.1-20.1 6.1-6.9-1.7-14.3-5.8-14.3-11.8V20c0-5 3.9-10.5 10.5-10.5h241.3c8.3 0 8.3 11.6 8.3 15.1 0 3.9 0 15.1-8.3 15.1H130.3v132.9h.3c104.2-109.8 282.8-36 282.8 108.9 0 178.1-244.8 220.3-310.1 62.8zm63.3-260.8c-.5 4.2 4.6 24.5 14.6 20.6C306 56.6 384 144.5 390.6 144.5c4.8 0 22.8-15.3 14.3-22.8-93.2-89-234.5-57-238.3-38.2zM393 414.7C283 524.6 94 475.5 61 310.5c0-12.2-30.4-7.4-28.9 3.3 24 173.4 246 256.9 381.6 121.3 6.9-7.8-12.6-28.4-20.7-20.4zM213.6 306.6c0 4 4.3 7.3 5.5 8.5 3 3 6.1 4.4 8.5 4.4 3.8 0 2.6.2 22.3-19.5 19.6 19.3 19.1 19.5 22.3 19.5 5.4 0 18.5-10.4 10.7-18.2L265.6 284l18.2-18.2c6.3-6.8-10.1-21.8-16.2-15.7L249.7 268c-18.6-18.8-18.4-19.5-21.5-19.5-5 0-18 11.7-12.4 17.3L234 284c-18.1 17.9-20.4 19.2-20.4 22.6z"/></svg>',
    'github': '<svg class="px-fa" aria-hidden="true" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 496 512"><path d="M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z"/></svg>',
    'my-linkedin': '<svg class="px-fa" aria-hidden="true" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z"/></svg>',
    'my-publications': '<svg class="px-fa" aria-hidden="true" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M364.2 83.8c-24.4-24.4-64-24.4-88.4 0l-184 184c-42.1 42.1-42.1 110.3 0 152.4s110.3 42.1 152.4 0l152-152c10.9-10.9 28.7-10.9 39.6 0s10.9 28.7 0 39.6l-152 152c-64 64-167.6 64-231.6 0s-64-167.6 0-231.6l184-184c46.3-46.3 121.3-46.3 167.6 0s46.3 121.3 0 167.6l-176 176c-28.6 28.6-75 28.6-103.6 0s-28.6-75 0-103.6l144-144c10.9-10.9 28.7-10.9 39.6 0s10.9 28.7 0 39.6l-144 144c-6.7 6.7-6.7 17.7 0 24.4s17.7 6.7 24.4 0l176-176c24.4-24.4 24.4-64 0-88.4z"/></svg>',
    'events-and-traveling': '<svg class="px-fa" aria-hidden="true" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M184 48H328c4.4 0 8 3.6 8 8V96H176V56c0-4.4 3.6-8 8-8zm-56 8V96H64C28.7 96 0 124.7 0 160v96H192 320 512V160c0-35.3-28.7-64-64-64H384V56c0-30.9-25.1-56-56-56H184c-30.9 0-56 25.1-56 56zM512 288H320v32c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V288H0V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V288z"/></svg>',
    'books': '<svg class="px-fa" aria-hidden="true" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M0 48V487.7C0 501.1 10.9 512 24.3 512c5 0 9.9-1.5 14-4.4L192 400 345.7 507.6c4.1 2.9 9 4.4 14 4.4c13.4 0 24.3-10.9 24.3-24.3V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48z"/></svg>',
    'security-news': '<svg class="px-fa" aria-hidden="true" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M96 96c0-35.3 28.7-64 64-64H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H80c-44.2 0-80-35.8-80-80V128c0-17.7 14.3-32 32-32s32 14.3 32 32V400c0 8.8 7.2 16 16 16s16-7.2 16-16V96zm64 24v80c0 13.3 10.7 24 24 24H296c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24H184c-13.3 0-24 10.7-24 24zm208-8c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H384c-8.8 0-16 7.2-16 16zm0 96c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H384c-8.8 0-16 7.2-16 16zM160 304c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm0 96c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16z"/></svg>',
    'field-notes': '<svg class="px-fa" aria-hidden="true" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192z"/></svg>',
    'penetration-testing': '<svg class="px-fa" aria-hidden="true" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 0c4.6 0 9.2 1 13.4 2.9L457.7 82.8c22 9.3 38.4 31 38.3 57.2c-.5 99.2-41.3 280.7-213.6 363.2c-16.7 8-36.1 8-52.8 0C57.3 420.7 16.5 239.2 16 140c-.1-26.2 16.3-47.9 38.3-57.2L242.7 2.9C246.8 1 251.4 0 256 0zm0 66.8V444.8C394 378 431.1 230.1 432 141.4L256 66.8l0 0z"/></svg>',
    'skills-lab': '<svg class="px-fa" aria-hidden="true" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M288 0H160 128C110.3 0 96 14.3 96 32s14.3 32 32 32V196.8c0 11.8-3.3 23.5-9.5 33.5L10.3 406.2C3.6 417.2 0 429.7 0 442.6C0 480.9 31.1 512 69.4 512H378.6c38.3 0 69.4-31.1 69.4-69.4c0-12.8-3.6-25.4-10.3-36.4L329.5 230.4c-6.2-10.1-9.5-21.7-9.5-33.5V64c17.7 0 32-14.3 32-32s-14.3-32-32-32H288zM192 196.8V64h64V196.8c0 23.7 6.6 46.9 19 67.1L309.5 320h-171L173 263.9c12.4-20.2 19-43.4 19-67.1z"/></svg>',
    'digital-forensics': '<svg class="px-fa" aria-hidden="true" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"/></svg>',
    'research': '<svg class="px-fa" aria-hidden="true" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M96 0C43 0 0 43 0 96V416c0 53 43 96 96 96H384h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V384c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H384 96zm0 384H352v64H96c-17.7 0-32-14.3-32-32s14.3-32 32-32zm32-240c0-8.8 7.2-16 16-16H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16zm16 48H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16z"/></svg>',
    'my-medium': '<svg class="px-fa" aria-hidden="true" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><path d="M180.5,74.262C80.813,74.262,0,155.633,0,256S80.819,437.738,180.5,437.738,361,356.373,361,256,280.191,74.262,180.5,74.262Zm288.25,10.646c-49.845,0-90.245,76.619-90.245,171.095s40.406,171.1,90.251,171.1,90.251-76.619,90.251-171.1H559C559,161.5,518.6,84.908,468.752,84.908Zm139.506,17.821c-17.526,0-31.735,68.628-31.735,153.274s14.2,153.274,31.735,153.274S640,340.631,640,256C640,171.351,625.785,102.729,608.258,102.729Z"/></svg>',
    'privacy-policy-and-cookie-policy': '<svg class="px-fa" aria-hidden="true" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M247.2 17c-22.1-3.1-44.6 .9-64.4 11.4l-74 39.5C89.1 78.4 73.2 94.9 63.4 115L26.7 190.6c-9.8 20.1-13 42.9-9.1 64.9l14.5 82.8c3.9 22.1 14.6 42.3 30.7 57.9l60.3 58.4c16.1 15.6 36.6 25.6 58.7 28.7l83 11.7c22.1 3.1 44.6-.9 64.4-11.4l74-39.5c19.7-10.5 35.6-27 45.4-47.2l36.7-75.5c9.8-20.1 13-42.9 9.1-64.9l-14.6-82.8c-3.9-22.1-14.6-42.3-30.7-57.9L388.9 57.5c-16.1-15.6-36.6-25.6-58.7-28.7L247.2 17zM208 144a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM144 336a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm224-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"/></svg>',
    'impressum': '<svg class="px-fa" aria-hidden="true" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm80 256h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zm-32-96a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm256-32H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16z"/></svg>',
    'learning': '<svg class="px-fa" aria-hidden="true" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 398.8c-11.8 5.1-23.4 9.7-34.9 13.5c16.7 33.8 31 35.7 34.9 35.7s18.1-1.9 34.9-35.7c-11.4-3.9-23.1-8.4-34.9-13.5zM446 256c33 45.2 44.3 90.9 23.6 128c-20.2 36.3-62.5 49.3-115.2 43.2c-22 52.1-55.6 84.8-98.4 84.8s-76.4-32.7-98.4-84.8c-52.7 6.1-95-6.8-115.2-43.2C21.7 346.9 33 301.2 66 256c-33-45.2-44.3-90.9-23.6-128c20.2-36.3 62.5-49.3 115.2-43.2C179.6 32.7 213.2 0 256 0s76.4 32.7 98.4 84.8c52.7-6.1 95 6.8 115.2 43.2c20.7 37.1 9.4 82.8-23.6 128zm-65.8 67.4c-1.7 14.2-3.9 28-6.7 41.2c31.8 1.4 38.6-8.7 40.2-11.7c2.3-4.2 7-17.9-11.9-48.1c-6.8 6.3-14 12.5-21.6 18.6zm-6.7-175.9c2.8 13.1 5 26.9 6.7 41.2c7.6 6.1 14.8 12.3 21.6 18.6c18.9-30.2 14.2-44 11.9-48.1c-1.6-2.9-8.4-13-40.2-11.7zM290.9 99.7C274.1 65.9 259.9 64 256 64s-18.1 1.9-34.9 35.7c11.4 3.9 23.1 8.4 34.9 13.5c11.8-5.1 23.4-9.7 34.9-13.5zm-159 88.9c1.7-14.3 3.9-28 6.7-41.2c-31.8-1.4-38.6 8.7-40.2 11.7c-2.3 4.2-7 17.9 11.9 48.1c6.8-6.3 14-12.5 21.6-18.6zM110.2 304.8C91.4 335 96 348.7 98.3 352.9c1.6 2.9 8.4 13 40.2 11.7c-2.8-13.1-5-26.9-6.7-41.2c-7.6-6.1-14.8-12.3-21.6-18.6zM336 256a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm-80-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"/></svg>',
};

// First, define the NavigationIconManager class and its dependencies
const navigationIcons = {
    // Existing icons
    // home: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>`,
    home: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="size-6"><path stroke-linecap="round" stroke-linejoin="round" d="m2.25 12 8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25" /></svg>`,
    blog: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path></svg>`,
    work: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather"><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path></svg>`,
    author: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>`,

    // Additional icons
    now: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather"><path d="M20.24 12.24a6 6 0 0 0-8.49-8.49L5 10.5V19h8.5z"></path><line x1="16" y1="8" x2="2" y2="22"></line><line x1="17.5" y1="15" x2="9" y2="15"></line></svg>`,
    course: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path></svg>`,
    faq: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>`,
    about: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>`,
    contact: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather"><circle cx="12" cy="12" r="4"></circle><path d="M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-3.92 7.94"></path></svg>`,
    books: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path></svg>`,
    bookmarks: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather"><path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"></path></svg>`,
    podcasts: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather"><path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"></path><path d="M19 10v2a7 7 0 0 1-14 0v-2"></path><line x1="12" y1="19" x2="12" y2="23"></line><line x1="8" y1="23" x2="16" y2="23"></line></svg>`,
    newsletters: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather"><polyline points="22 12 16 12 14 15 10 15 8 12 2 12"></polyline><path d="M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"></path></svg>`,
    tools: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path></svg>`,
    gallery: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-grid"><rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect><rect x="14" y="14" width="7" height="7"></rect><rect x="3" y="14" width="7" height="7"></rect></svg>`,

    // Social icons
    instagram: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line></svg>`,
    twitter: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather"><path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"></path></svg>`,
    linkedin: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path><rect x="2" y="9" width="4" height="12"></rect><circle cx="4" cy="4" r="2"></circle></svg>`,
    facebook: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path></svg>`,
    github: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather"><path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22"></path></svg>`,
    shop: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>`,
    youtube: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather"><path d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z"></path><polygon points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02"></polygon></svg>`,

    // Home icon aliases
    homepage: function() { return this.home; },
    'main-page': function() { return this.home; },
    start: function() { return this.home; },
    'home-page': function() { return this.home; },
    dashboard: function() { return this.home; },

    // Now icon aliases
    current: function() { return this.now; },
    'now-page': function() { return this.now; },
    updates: function() { return this.now; },
    'whats-new': function() { return this.now; },
    status: function() { return this.now; },

    // Course icon aliases
    courses: function() { return this.course; },
    learning: function() { return this.course; },
    tutorials: function() { return this.course; },
    lessons: function() { return this.course; },
    education: function() { return this.course; },
    'online-courses': function() { return this.course; },

    // About icon aliases
    'about-me': function() { return this.about; },
    biography: function() { return this.about; },
    info: function() { return this.about; },
    introduction: function() { return this.about; },
    'about-us': function() { return this.about; },

    // FAQ icon aliases
    faqs: function() { return this.faq; },
    help: function() { return this.faq; },
    questions: function() { return this.faq; },
    'help-center': function() { return this.faq; },
    support: function() { return this.faq; },

    // Bookmarks icon aliases
    favorites: function() { return this.bookmarks; },
    saved: function() { return this.bookmarks; },
    'reading-list': function() { return this.bookmarks; },
    'saved-items': function() { return this.bookmarks; },
    collections: function() { return this.bookmarks; },

    // Podcasts icon aliases
    audio: function() { return this.podcasts; },
    episodes: function() { return this.podcasts; },
    shows: function() { return this.podcasts; },
    'podcast-episodes': function() { return this.podcasts; },
    broadcasts: function() { return this.podcasts; },

    // Newsletters icon aliases
    digest: function() { return this.newsletters; },
    updates: function() { return this.newsletters; },
    'email-updates': function() { return this.newsletters; },
    subscription: function() { return this.newsletters; },
    'mailing-list': function() { return this.newsletters; },

    // Gallery icon aliases
    photos: function() { return this.gallery; },
    images: function() { return this.gallery; },
    portfolio: function() { return this.gallery; },
    'photo-gallery': function() { return this.gallery; },
    'image-gallery': function() { return this.gallery; },
    showcase: function() { return this.gallery; },
    albums: function() { return this.gallery; },

    // Blog icon aliases
    posts: function() { return this.blog; },
    articles: function() { return this.blog; },
    writing: function() { return this.blog; },
    journal: function() { return this.blog; },
    'latest-posts': function() { return this.blog; },
    'my-blog': function() { return this.blog; },
    diary: function() { return this.blog; },
    thoughts: function() { return this.blog; },
    notes: function() { return this.blog; },
    'writing-archive': function() { return this.blog; },
     
    profile: function() { return this.author; },
    bio: function() { return this.author; },
     
    // Books icon aliases
    library: function() { return this.books; },
    reading: function() { return this.books; },
    'my-library': function() { return this.books; },
    'reading-list': function() { return this.books; },
    bookshelf: function() { return this.books; },
    'book-notes': function() { return this.books; },
    'book-reviews': function() { return this.books; },
    'recommended-books': function() { return this.books; },
    literature: function() { return this.books; },
    publications: function() { return this.books; },
     
    // Work icon aliases
    portfolio: function() { return this.work; },
    projects: function() { return this.work; },
    'my-work': function() { return this.work; },
    'case-studies': function() { return this.work; },
    experience: function() { return this.work; },
    'my-projects': function() { return this.work; },
    showcase: function() { return this.work; },
    achievements: function() { return this.work; },
    career: function() { return this.work; },
    'work-history': function() { return this.work; },
     
    social: function() { return this.contact; },
    connect: function() { return this.contact; },
     
    // Tools icon aliases
    resources: function() { return this.tools; },
    utilities: function() { return this.tools; },
    'my-tools': function() { return this.tools; },
    software: function() { return this.tools; },
    applications: function() { return this.tools; },
    'tool-kit': function() { return this.tools; },
    gear: function() { return this.tools; },
    equipment: function() { return this.tools; },
    'useful-tools': function() { return this.tools; },
    'resource-library': function() { return this.tools; },

    // Twitter icon aliases
    'x': function() { return this.twitter; },

    // Default fallback icon
    default: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-hash"><line x1="4" y1="9" x2="20" y2="9"></line><line x1="4" y1="15" x2="20" y2="15"></line><line x1="10" y1="3" x2="8" y2="21"></line><line x1="16" y1="3" x2="14" y2="21"></line></svg>`
};

class NavigationManager {
    constructor() {
        this.icons = Object.assign(navigationIcons, pxNavIcons);
        this.HEADER_PREFIX = "#";
        this.initialized = false;
        this.originalItems = null;
        this.pendingIcons = new Map(); // Store icons that are set before first initialization

        window.navIcons = {
            setIcon: (slug, svgContent) => {
                if (!slug || typeof svgContent !== 'string') {
                    console.warn('Invalid icon definition:', { slug, svgContent });
                    return;
                }
                // Prospero: the theme already ships these icons inline; ignore the old
                // Font Awesome <i> tags from code injection (they caused the flash)
                if (pxNavIcons[slug.toLowerCase()] && /^<i\b/.test(svgContent.trim())) return;

                // If not yet initialized, store for later
                if (!this.initialized) {
                    this.pendingIcons.set(slug.toLowerCase(), svgContent);
                    return;
                }
                
                // If already initialized, update and re-render
                this.icons[slug.toLowerCase()] = svgContent;
                this.updateIcons();
            },
            initializeNavigation: () => {
                this.initialize(true);
            },
            getIcon: (slug) => this.getIcon(slug)
        };
    }

    initialize(force = false) {
        if (this.initialized && !force) return;
        
        const headMenu = document.querySelector(".head-menu");
        if (!headMenu) return;

        // Apply any pending icons first
        if (this.pendingIcons.size > 0) {
            this.pendingIcons.forEach((svg, slug) => {
                this.icons[slug] = svg;
            });
            this.pendingIcons.clear();
        }

        // Store original items on first initialization
        if (!this.originalItems) {
            this.originalItems = Array.from(document.querySelectorAll(".head-menu .nav li"));
        }
        
        // Process and render
        const groups = this.processMenuItems(this.originalItems);
        this.renderGroups(headMenu, groups);
        
        this.initialized = true;
        headMenu.classList.add('initialized');
    }

    updateIcons() {
        const headMenu = document.querySelector(".head-menu");
        if (!headMenu) return;

        const groups = this.processMenuItems(this.originalItems);
        this.renderGroups(headMenu, groups);
    }

    processMenuItems(items) {
        return items.reduce((acc, item) => {
            const text = item.textContent.trim();
            const currentGroup = acc[acc.length - 1];
            
            if (text.startsWith(this.HEADER_PREFIX)) {
                acc.push({
                    header: text.slice(1),
                    items: []
                });
            } else {
                const link = item.querySelector("a");
                const slug = this.getNavSlug(item);
                
                if (currentGroup) {
                    currentGroup.items.push({
                        text,
                        link: link.href,
                        classNames: item.className,
                        icon: slug ? this.getIcon(slug) : '',
                    });
                }
            }
            return acc;
        }, [{ header: null, items: [] }]);
    }

    getNavSlug(element) {
        return Array.from(element.classList)
            .find(cls => cls.startsWith('nav-') && 
                        cls !== 'nav-item' && 
                        cls !== 'nav-current')
            ?.replace('nav-', '');
    }

    getIcon(slug) {
        if (!slug) return this.icons.default;
        
        const icon = this.icons[slug.toLowerCase()];
        
        if (typeof icon === 'function') {
            return icon.call(this.icons); // Call the alias function with icons object as context
        }
        
        return icon || this.icons.default;
    }

    renderGroups(headMenu, groups) {
        const fragment = document.createDocumentFragment();
        const container = document.createElement('div');
        container.className = "menu-item";

        groups.forEach(group => {
            if (group.items.length === 0) return;

            const div = document.createElement('div');
            div.className = "head-group";

            div.innerHTML = group.header 
                ? this.createGroupWithHeader(group)
                : this.createGroupWithoutHeader(group);

            container.appendChild(div);
        });

        fragment.appendChild(container);
        headMenu.innerHTML = '';
        headMenu.appendChild(fragment);
    }

    createGroupWithHeader(group) {
        return `
            <h6 class="head-group-header section-title">${group.header}</h6>
            ${this.createNavList(group.items)}
        `;
    }

    createGroupWithoutHeader(group) {
        return this.createNavList(group.items);
    }

    createNavList(items) {
        return `
            <ul class="nav">${
                items.map(item => `
                    <li class="nav-item ${item.classNames}">
                        <a href="${item.link}">
                            ${item.icon ? `<div class="nav-icon">${item.icon}</div>` : ''}
                            ${item.text}
                        </a>
                    </li>
                `).join('')
            }</ul>
        `;
    }
}

// Initialize as early as possible
window.navigationManager = new NavigationManager();
window.navigationManager.initialize();

// Backup initialization
document.addEventListener('DOMContentLoaded', () => {
    if (!window.navigationManager.initialized) {
        window.navigationManager.initialize();
    }
});

dropdown(false);

function portalButton() {
    'use strict';
    st = window.scrollY;

    if (st > 300) {
        body.classList.add('portal-visible');
    } else {
        body.classList.remove('portal-visible');
    }
}

function featured() {
    'use strict';
    var feed = document.querySelector('.featured-feed');
    if (!feed) return;

    tns({
        container: feed,
        controlsText: [
            '<svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M20.547 22.107L14.44 16l6.107-6.12L18.667 8l-8 8 8 8 1.88-1.893z"></path></svg>',
            '<svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M11.453 22.107L17.56 16l-6.107-6.12L13.333 8l8 8-8 8-1.88-1.893z"></path></svg>',
        ],
        gutter: 24,
        loop: false,
        nav: false,
        mouseDrag: true,
        responsive: {
            0: {
                items: 2,
            },
            768: {
                items: 2,
            },
            992: {
                items: 2,
            },
        },
    });
}

function darkPage() {
    var isDark = body.classList.contains('tag-hash-dark') ? 'dark' : 'light';
    html.classList.add(`${isDark}-page`);
}

function footerGroup() {
    const footerNav = document.querySelector(".footer-nav");
    if (!footerNav) return;
    
    const items = document.querySelectorAll(".footer-nav .nav li");

    const groups = [];
    let index = null;
    items.forEach(item => {
        const text = item.textContent.trim();
        const PREFIXFOOTERHEADER = "#";
        if (text.includes(PREFIXFOOTERHEADER)) {
            index = index === null ? 0 : ++index;
            groups[index] = { header: "", items: [] };
            groups[index].header = text.slice(PREFIXFOOTERHEADER.length);
        } else {
            groups[index].items.push({ text, link: item.childNodes[0].href });
        }
    })
    document.querySelector(".footer-nav ul.nav").remove();
    groups.forEach((group) => {
        const div = document.createElement('div');
        const h6 = document.createElement('h6');
        h6.classList.add("footer-group-header", "section-title");
        h6.innerHTML = group.header;
        const ul = document.createElement("ul");
        ul.classList.add("nav");
        group.items.forEach((item) => {
            const li = document.createElement("li");
            li.innerHTML = `<a href="${item.link}">${item.text}</a>`;
            ul.append(li);
        })
        div.append(h6, ul);
        footerNav.appendChild(div);
    });
}

function categoryNav() {
    var currentPageURL = window.location.pathname;

    // Get all <a> tags inside the .blog-navbar div
    var navbarLinks = document.querySelectorAll('.blog-navbar a');

    // Loop through each <a> tag
    navbarLinks.forEach(function(link) {
        // Check if the href attribute matches the current page URL
        if (link.getAttribute('href') === currentPageURL) {
            // Add the is-active class
            link.classList.add('is-active');
        }
    });
}

function initMasonryLayout() {
    const container = document.querySelector('.masonry-container');
    if (!container) return;
    
    // Store original order if not already stored
    if (!container.dataset.originalOrder) {
        const items = Array.from(document.querySelectorAll('.masonry-brick'));
        // Store just the IDs or data attributes that uniquely identify each brick
        container.dataset.originalOrder = items.map(item => 
            item.id || item.dataset.id || item.dataset.index || items.indexOf(item)
        ).join(',');
    }
    
    // Get current items and sort them according to original order
    const currentItems = Array.from(document.querySelectorAll('.masonry-brick'));
    const originalOrder = container.dataset.originalOrder.split(',');
    
    // Sort items based on original order
    const items = originalOrder.map(id => 
        currentItems.find(item => 
            (item.id || item.dataset.id || item.dataset.index || currentItems.indexOf(item)) == id
        )
    );
    
    if (!items.length) return;
    
    // Create wrapper
    const wrapper = document.createElement('div');
    wrapper.className = 'masonry-wrapper gh-feed';
    
    // Create temporary wrapper to get computed style
    container.appendChild(wrapper);
    const computedStyle = getComputedStyle(wrapper);
    const columnCount = parseInt(computedStyle.getPropertyValue('--columns')) || 5;
    container.removeChild(wrapper);
    
    // Create columns
    const columns = Array.from({ length: columnCount }, () => {
        const column = document.createElement('div');
        column.className = 'masonry-column';
        wrapper.appendChild(column);
        return column;
    });
    
    // Distribute items to columns horizontally
    items.forEach((item, index) => {
        const columnIndex = index % columnCount;
        columns[columnIndex].appendChild(item);
    });
    
    // Replace existing content
    const existingWrapper = container.querySelector('.masonry-wrapper');
    if (existingWrapper) {
        container.replaceChild(wrapper, existingWrapper);
    } else {
        container.appendChild(wrapper);
    }
    
    // Handle image loading
    const images = document.querySelectorAll('.masonry-content img');
    let loadedImages = 0;
    const totalImages = images.length;
    
    const imageLoaded = () => {
        loadedImages++;
        if (loadedImages === totalImages) {
            wrapper.classList.remove('is-loading');
            initLightbox();
        }
    };

    images.forEach(img => {
        if (img.complete) {
            imageLoaded();
        } else {
            img.addEventListener('load', imageLoaded, { once: true });
            img.addEventListener('error', imageLoaded, { once: true });
        }
    });

    if (loadedImages === totalImages) {
        wrapper.classList.remove('is-loading');
        initLightbox();
    }
}

// Add resize handler with debounce
let resizeTimeout;
window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(initMasonryLayout, 250);
});

function initLightbox() {
    const masonryImages = document.querySelectorAll('.masonry-content .zoom-image');
    if (!masonryImages.length) return;

    const pswpElement = document.querySelector('.pswp');
    if (!pswpElement) return;

    // Function to reset PhotoSwipe DOM to initial state
    function resetPhotoSwipe() {
        // Remove all added classes from root element
        pswpElement.className = 'pswp';
        
        // Reset container
        const container = pswpElement.querySelector('.pswp__container');
        container.removeAttribute('style');
        
        // Reset items
        const items = container.querySelectorAll('.pswp__item');
        items.forEach(item => {
            item.removeAttribute('style');
            item.innerHTML = ''; // Remove any zoom wraps and images
        });
        
        // Reset UI elements
        const uiElements = pswpElement.querySelectorAll('.pswp__button');
        uiElements.forEach(el => {
            el.classList.remove('pswp__element--disabled');
        });
        
        // Reset counter
        const counter = pswpElement.querySelector('.pswp__counter');
        if (counter) counter.textContent = '';
        
        // Reset UI visibility
        const ui = pswpElement.querySelector('.pswp__ui');
        ui.className = 'pswp__ui pswp__ui--hidden';
    }

    // Remove existing click listeners and create items array once
    const items = Array.from(masonryImages).map((image) => ({
        src: image.dataset.original || image.src,
        msrc: image.dataset.small,
        w: image.naturalWidth || 0,
        h: image.naturalHeight || 0,
        el: image
    }));

    function handleImageClick(e) {
        e.preventDefault();
        resetPhotoSwipe();
        
        // Find current index from pre-built items array
        const currentIndex = items.findIndex(item => item.el === e.target);
        if (currentIndex === -1) return;

        const options = {
            index: currentIndex,
            bgOpacity: 0.9,
            closeOnScroll: true,
            fullscreenEl: false,
            history: false,
            shareEl: false,
            zoomEl: true,
            getThumbBoundsFn: (index) => {
                const thumbnail = items[index].el;
                const rect = thumbnail.getBoundingClientRect();
                return {
                    x: rect.left,
                    y: rect.top + window.scrollY,
                    w: rect.width
                };
            }
        };

        const gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
        
        gallery.listen('destroy', function() {
            gallery.close();
            resetPhotoSwipe();
        });

        gallery.init();
    }

    // Add click listeners
    masonryImages.forEach((img) => {
        img.removeEventListener('click', handleImageClick);
        img.addEventListener('click', handleImageClick);
    });
}

function setupFootnotes() {
    'use strict';
    const contentSelector = 'article.ghost-content';
    const contentElement = document.querySelector(contentSelector);
    if (!contentElement) return;

    let htmlContent = contentElement.innerHTML;
    const regexPattern = /\[\^(.*?)\]/g;
    
    // Check if there are any footnotes before proceeding
    const matches = htmlContent.match(regexPattern);
    if (!matches) return;

    const footnoteList = document.createElement('ol');
    footnoteList.classList.add('footnote-list');
    footnoteList.id = 'footnotes';
    
    const footnoteWrapper = document.createElement('div');
    footnoteWrapper.classList.add('kg-canvas', 'section-footnotes');
    
    let index = 1;
    
    htmlContent = htmlContent.replace(regexPattern, (match, p1) => {
        footnoteList.innerHTML = footnoteList.innerHTML + `<li id="footnote-${index}">${p1}</li>`;
        const returnValue = `<sup class="footnote"><a href="#footnote-${index}">[${index}]</a></sup>`;
        index++;
        return returnValue;
    });

    contentElement.innerHTML = htmlContent;
    
    footnoteWrapper.appendChild(footnoteList);
    contentElement.appendChild(footnoteWrapper);
}

function setMasonryAnimationDelay() {
    const bricks = document.querySelectorAll('.masonry-brick');
    bricks.forEach((brick, index) => {
        brick.style.animationDelay = `${index * 0.05}s`;
    });
}

// Sidebar overlay logic for desktop
(function() {
  function isDesktop() {
    return window.innerWidth >= 768;
  }
  function setupSidebarOverlay() {
    var bodyEl = document.body;
    if (!bodyEl.classList.contains('sidebar-overlay')) return;
    var burger = document.querySelector('.sidebar-burger');
    var sidebar = document.getElementById('gh-head');
    if (!burger || !sidebar) return;
    // Add overlay bg if not present
    if (!document.querySelector('.sidebar-overlay-bg')) {
      var overlayBg = document.createElement('div');
      overlayBg.className = 'sidebar-overlay-bg';
      document.body.appendChild(overlayBg);
    }
    var overlayBg = document.querySelector('.sidebar-overlay-bg');
    function openSidebar() {
      bodyEl.classList.add('sidebar-open');
    }
    function closeSidebar() {
      bodyEl.classList.remove('sidebar-open');
    }
    burger.addEventListener('click', function(e) {
      if (!isDesktop()) return;
      openSidebar();
    });
    overlayBg.addEventListener('click', function(e) {
      closeSidebar();
    });
    // Close on resize to mobile
    window.addEventListener('resize', function() {
      if (!isDesktop()) closeSidebar();
    });
    // Hide sidebar by default on desktop
    if (isDesktop()) closeSidebar();
  }
  document.addEventListener('DOMContentLoaded', setupSidebarOverlay);
})();